/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVoucherDto } from '../../models/update-voucher-dto';
import { VoucherDto } from '../../models/voucher-dto';

export interface CenterVoucherControllerUpdate$Params {
  id: string;
  centerId: string;
      body: UpdateVoucherDto
}

export function centerVoucherControllerUpdate(http: HttpClient, rootUrl: string, params: CenterVoucherControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
  const rb = new RequestBuilder(rootUrl, centerVoucherControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoucherDto>;
    })
  );
}

centerVoucherControllerUpdate.PATH = '/api/voucher/center/{id}';
